export function formatDecimal (value: number, formatStr: string): string {
  // eslint-disable-next-line eqeqeq
  if (formatStr == undefined) {
    return value.toString();
  }

  let nbInt = 0;
  let nbDec = 0;
  let separateurMiliers = '';
  const match = formatStr.match(/^(\D??)(\d*)(?:\.(\d+))?$/);
  if (match) {
    separateurMiliers = match[1];
    nbInt = parseInt(match[2]) || 0;
    nbDec = parseInt(match[3]) || 0;
  } else {
    throw new Error('formatDecimal : invalid format string : ' + formatStr + '. must be : "#", "#.#", ",#", ",#.#", ".#"');
  }

  let [intPart, decPart] = (value.toFixed(nbDec) + '').split('.');

  intPart = intPart.padStart(nbInt, '0');
  if (separateurMiliers) {
    intPart = intPart.replace(/\B(?=(\d{3})+(?!\d))/g, separateurMiliers);
  }

  if (decPart) {
    decPart = decPart.padEnd(nbDec, '0');
  }

  return intPart + (nbDec ? ',' + decPart : '');
}

export function formatCurrency (value: number): string {
  return formatDecimal(value, ' .2');
}
